import React from 'react';

const AppFooter = () => <div />;

export default AppFooter;
